//配置路由相关的信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import home from '../components/home.vue'
import introduce from '../components/introduce.vue'
import annual from '../components/annual.vue'
import council from '../components/council.vue'
import contact from '../components/contact.vue'
import council_details from '../components/council_details.vue'
import council_figure from '../components/council_figure.vue'
import finance from '../components/finance.vue'
import article from '../components/article'

//1.通过Vue.use(插件)，安装插件
Vue.use(VueRouter) //Vue中使用router插件

//2.创建VueRouter对象
const routes = [{
		//没写就是任意路由都是定向这个
		path: '/',
		
		//重定向
		redirect: '/home',
		meta:{
			title:'首页'
		}
	
	},
	{
		path: '/home',
		name: home, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/home.vue')
	},
	{
		path: '/introduce',
		name: introduce, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/introduce.vue')
	},
	{
		path: '/annual',
		name: annual, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/annual.vue')
	},
	{
		path: '/council',
		name: council, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/council.vue')
	},
	{
		path: '/contact',
		name: contact, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/contact.vue')
	},
	{
		path: '/council_details',
		name: council_details, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/council_details.vue')
	},
	{
		path: '/council_figure',
		name: council_figure, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/council_figure.vue')
	},
	{
		path: '/council_figure2',
		name: council_figure, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/council_figure2.vue')
	},
	{
		path: '/finance',
		name: finance, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/finance.vue')
	},
	{
		path: '/article',
		name: article, // 虽然这个路由被重定向，但是不要忘记 注册组件
		component: () => import('../components/article.vue')
	},
]

const router = new VueRouter({
	//配置路由和组件之间的应用关系
	routes
})
router.beforeEach((to, from, next) => {    
    // 兼容chrome
    document.body.scrollTop = 0
    // 兼容firefox
    document.documentElement.scrollTop = 0
    // 兼容safari
    window.pageYOffset = 0
    next()
})


//导出路由实例，在main.js中导入使用
export default router